import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './component/Home/Home';
import Header from './component/Header/Header';
import Footer from './component/Footer/Footer';
import AboutUs from './component/AboutUs/AboutUs';
import Automobile_glass from "./component/AboutUs/Products/Automobile_glass";
import Architectural_glass from "./component/AboutUs/Products/Architectural_glass";
import Director_message from "./component/AboutUs/Director_message";
import Vision_mission from "./component/AboutUs/Vission_mission";
import Our_strength from "./component/AboutUs/Our_strength";
import Our_value from "./component/AboutUs/Our_value";
import Principle_of_conduct from "./component/AboutUs/Principle_of_conduct";
import Award_media from "./component/AboutUs/Award_media";
import Automobile_tempered_glass from "./component/AboutUs/Products/Automobile_tempered_glass";
import Laminated_glass from "./component/AboutUs/Products/Laminated_glass";
import Heat_strengthened from "./component/AboutUs/Products/Heat_strengthened";
import Wind_screen_laminated from "./component/AboutUs/Products/Wind_screen_laminated";
import Bend_glass from "./component/AboutUs/Products/Bend_glass";
import Bullet_proof from "./component/AboutUs/Products/Bullet_proof";
import Glass_lids from "./component/AboutUs/Products/Glass_lids";
import Decorative_glass from "./component/AboutUs/Products/Decorative_glass";
import Aluminum_windows from "./component/AboutUs/Products/Aluminum_windows";
import Railways_glass from "./component/AboutUs/Products/Railways_glass";
import Product from './component/Products/Product';
import TemperableGlass from './component/Products/Glasses/TemperableGlass';
import ClearGlass from './component/Products/Glasses/ClearGlass';
import CrystalGrey from './component/Products/Glasses/CrystalGrey';
import EuroGrey from './component/Products/Glasses/EuroGrey';
import FrenchGreen from './component/Products/Glasses/FrenchGreen';
import UltraClear from './component/Products/Glasses/UltraClear';
import RequestQuote from './component/RequestQuote/RequestQuote';
import Faq from './component/Faq/Faq';
import ContactUs from './component/ContactUs/ContactUs';
import Sitemap from './component/Sitemap/Sitemap';
import PrivacyPolicy from './component/PrivacyPolicy/PrivacyPolicy';
import WindowGlass from './component/Products/Glasses/WindowGlass';
import CarGlass from './component/Products/Glasses/CarGlass';
import ERickshawSparePartsGlass from './component/Products/Glasses/ERickshawSparePartsGlass';
import AutomotiveGlass from './component/Products/Glasses/AutomotiveGlass';
import CommercialVehiclGlass from './component/Products/Glasses/CommercialVehiclGlass';
import AutomobileToughnessGlass from './component/Products/Glasses/AutomobileToughnessGlass';

import ScrollToTop from './ScrollToTop';
import PassengerTransportation from './component/Products/Glasses/PassengerTransportation';
import SpecialApplicationGlass from './component/Products/Glasses/SpecialApplicationGlass';
import HealthcareVehiclesGlass from './component/Products/Glasses/HealthcareVehiclesGlass';
import MiningandConstructionGlass from './component/Products/Glasses/MiningandConstructionGlass';
import LogisticsVehiclesGlass from './component/Products/Glasses/LogisticsVehiclesGlass';
import Automobile_Toughness_Glass from './component/AboutUs/Products/Automobile_Toughness_Glass';
import Automative_Laminated_Glass from './component/AboutUs/Products/Automative_Laminated_Glass';
import Arctitecture_Glass from './component/AboutUs/Products/Arctitecture_Glass';
import Home_Appliance_glasses from './component/AboutUs/Products/Home_Appliance_glasses';
import Railway_Window_Glass from './component/AboutUs/Products/Railway_Window_Glass';
import DGU_Glass from './component/AboutUs/Products/DGU_Glass';


function App() {
  return (

    <>
    <BrowserRouter>
    <ScrollToTop />
      <Routes>

        <Route path='' element={<Home/>}/>
        <Route path='/Header' element={<Header/>}/>
        <Route path='/Footer' element={<Footer/>}/>
        <Route path='/AboutUs' element={<AboutUs/>}/>
        <Route path='/Director_message' element={<Director_message/>}/>
        <Route path='/Vision_mission' element={<Vision_mission/>}/>
        <Route path='/Our_strength' element={<Our_strength/>}/>
        <Route path='/Our_value' element={<Our_value/>}/>
        <Route path='/Principle_of_conduct' element={<Principle_of_conduct/>}/>
        <Route path='/Award_media' element={<Award_media/>}/>

        <Route path='/Automotive_Railway_window_glass' element={<Automobile_glass/>}/>
        <Route path='/Car_Glass' element={<Architectural_glass/>}/>
        <Route path='/E_Rickshaw_Spare_Parts_Glass' element={<Automobile_tempered_glass/>}/>
        <Route path='/laminated_glass' element={<Laminated_glass/>}/>
        <Route path='/heat_strengthened' element={<Heat_strengthened/>}/>
        <Route path='/wind_screen_laminated' element={<Wind_screen_laminated/>}/>
        <Route path='/Commercial_Vehicle_Glass' element={<Bend_glass/>}/>

        <Route path='/glass_lids' element={<Glass_lids/>}/>
        <Route path='/decorative_glass' element={<Decorative_glass/>}/>
        <Route path='/Automotive_Glass' element={<Aluminum_windows/>}/>
        <Route path='/railways_glass' element={<Railways_glass/>}/>


        <Route path='/Product'  element={<Product/>}/>
        <Route path='/TemperableLowECoatedGlass'  element={<TemperableGlass/>}/>
        <Route path='/ClearGlass'  element={<ClearGlass/>}/>
        <Route path='/CrystalGrey'  element={<CrystalGrey/>}/>
        <Route path='/EuroGrey'  element={<EuroGrey/>}/>
        <Route path='/FrenchGreen'  element={<FrenchGreen/>}/>
        <Route path='/UltraClear'  element={<UltraClear/>}/>



        <Route path='/Request_A_Quote'  element={<RequestQuote/>}/>
        <Route path='/Faq'  element={<Faq/>}/>
        <Route path='/ContactUs'  element={<ContactUs/>}/>

        <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>}/>
        <Route path='/Sitemap' element={<Sitemap/>}/>

        <Route path='/WindowGlass' element={<WindowGlass/>}/>
        <Route path='/CarGlass' element={<CarGlass/>}/>
        <Route path='/ERickshawSparePartsGlass' element={<ERickshawSparePartsGlass/>}/>
        <Route path='/AutomotiveGlass' element={<AutomotiveGlass/>}/>
        <Route path='/CommercialVehiclGlass' element={<CommercialVehiclGlass/>}/>
        <Route path='/AutomobileToughnessGlass' element={<AutomobileToughnessGlass/>}/>


        <Route path='/PassengerTransportation' element={<PassengerTransportation/>} />
        <Route path='/SpecialApplicationVehicles' element={<SpecialApplicationGlass/>}/>
        <Route path='/HealthcareVehiclesGlass' element={<HealthcareVehiclesGlass/>}/>
        <Route path='/MiningandConstructionGlass' element={<MiningandConstructionGlass/>}/>
        <Route path='/LogisticsVehiclesGlass' element={<LogisticsVehiclesGlass/>}/>


        <Route path='/Automobile_Toughness_Glass' element={<Automobile_Toughness_Glass/>}/>
        <Route path='/Construction_Equipment_Glass' element={<Bullet_proof/>}/>
        <Route path='/Automative_Laminated_Glass' element={<Automative_Laminated_Glass/>}/>
        <Route path='/Arctitecture_Glass' element={<Arctitecture_Glass/>}/>
        <Route path='/Home_Appliance_glasses' element={<Home_Appliance_glasses/>}/>
        <Route path='/Railway_Window_Glass' element={<Railway_Window_Glass/>}/>
        <Route path='/DGU_Glass' element={<DGU_Glass/>}/>
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
